import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Document } from 'models/DocumentModel';


const DocumentList: React.FC = () => {
  const width = { type: 12, client: 18, comment: 28, date: 12, fileno: 12, user:12 }
  const [formId, formName] = [Code.Form.Id.DOCUMENT, Code.Form.Name.DOCUMENT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [documentData, setDocumentData] = useState<Document[]>([]); 
  const [selectedDocument, setselectedDocument] = useState<Document | null>(null);
  
  const triggers = [pno, rows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Document.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Document.Date, 
        Name.Common.TypeName, 
        Name.Client.FullName, 
        Name.Document.Comment, 
        Name.Document.Date, 
        Name.Document.FileNo, 
        Name.User.FullName
      ]),
    });
     
    await API.Data.List<Document>(url, setDocumentData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, documentData, setSelectAllChecked,formName)} extra={2} />
              <Control.Grid.Items values={[
                [Title.Type, width.type],
                [Title.ClientName, width.client],
                [Title.Comment, width.comment], 
                [Title.Date, width.date], 
                [Title.FileNo, width.fileno], 
                [Title.UserName, width.user], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(documentData) && (
              <Control.Grid.Row>
                {documentData.map((documentData) => { return (
                <Control.Grid.Data<Document> key={documentData.document_id} itemKey={documentData.document_key} data={documentData} setMenuPosition={setMenuPosition} setSelectedData={setselectedDocument} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={documentData.document_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, documentData.document_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Preview path={Utility.Join.Print(Privilege, formName, documentData.document_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [documentData.type_name, width.type],
                    [Utility.Get.FullName(documentData,Code.Form.Name.CLIENT), width.client],
                    [documentData.document_comment, width.comment],
                    [Utility.Format.DateOnly(documentData.document_date), width.date],
                    [documentData.document_file_no, width.fileno],
                    [Utility.Get.FullName(documentData,Code.Form.Name.USER), width.user],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={documentData.document_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={documentData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedDocument?.document_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedDocument?.document_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default DocumentList;